import type { ProductImportRejectionReason, ProductImportWarningType } from '../types';
import {
  MAX_PRODUCT_DESCRIPTION_LENGTH,
  MAX_PRODUCT_NAME_LENGTH,
  MAX_PRODUCT_PRICE_RANGE_LENGTH,
} from './productLimits';
import { MAX_PRODUCT_ALIAS_LENGTH, MAX_PRODUCT_ALIASES } from './productNaming';

const REJECTION_LIMITS: Partial<Record<ProductImportRejectionReason, number>> = {
  name_too_long: MAX_PRODUCT_NAME_LENGTH,
  description_too_long: MAX_PRODUCT_DESCRIPTION_LENGTH,
  price_range_too_long: MAX_PRODUCT_PRICE_RANGE_LENGTH,
};

export const importRejectionParams = (
  reason: ProductImportRejectionReason,
): { max: number } | undefined => {
  const max = REJECTION_LIMITS[reason];
  return max === undefined ? undefined : { max };
};

export const importWarningParams = (
  warning: ProductImportWarningType,
): { maxCount: number; maxLength: number } | undefined =>
  warning === 'aliases_truncated'
    ? { maxCount: MAX_PRODUCT_ALIASES, maxLength: MAX_PRODUCT_ALIAS_LENGTH }
    : undefined;
